// import { mapState } from 'vuex';

export default {
  data: () => {
    return {
      detachFileDialog: false,
      dummyFile: null,
      filename: null,
      validFilename: true,
      deletedVariationFragments: [],
      valueVariationsToDelete: [],
      variationFragments: {},
      loading: false,
      variationFragmentFetchAttempts: 0,
      variations: {},
      filename: null,
      localPreview: false, // indicates if this is a newly selected (local) image, or a remote one
      url: null,
      enhancedRules: [],
    };
  },
  methods: {
    getLocalValue() {
      console.log('Not implemented in the shared mixin.');
    },
    async download() {
      const fragment = await this.$store.state.sdk.getDocument(this.value.variations._default);
      const chunks = fragment.path.split('/');
      const url = await this.$store.state.sdk.getSignedDownloadUrl(fragment.path, chunks.pop());
      window.location = url;
    },
    async setLocalPreview(event) {
      if (event) {
        this.filename = event.name
        this.localPreview = true;
        this.value = {
          data: await this.getLocalValue(event),
          file: event
        };
      } else {
        this.localPreview = false;
        this.url = null;
      }
    },
    async confirmFragmentDeleted(variationName, path) {
      // TODO: fix this inconsistency!
      let valueVariations;
      if (this.$options.name === 'LeanFile') {
        valueVariations = { _default: this.value };
      } else if (this.$options.name === 'LeanImage') {
        valueVariations = this.value;
      } else {
        valueVariations = this.value.variations;
      }

      try {
        // a HTTP HEAD request will attempt to get the HTTP Headers for this file
        const head = await this.$store.state.sdk.headDocument(path);
      } catch (err) {
        this.deletedVariationFragments.push(variationName);
        if (this.deletedVariationFragments.length === Object.keys(valueVariations).length) {
          return this.unsetValue();
        } else {
          return;
        }
      }

      // no caught error means the HTTP HEAD request was 200 OK, we need to try again
      setTimeout(this.confirmFragmentDeleted, 2000, variationName, this.value[variationName]);
    },
    async detachFiles() {
      if (this.localPreview) {
        return this.unsetValue();
      }

      let value;

      // TODO: fix this inconsistency!
      if (this.$options.name === 'LeanFile') {
        value = { _default: this.value } || null;
      } else if (this.$options.name === 'LeanImage') {
        value = this.value || null;
      } else {
        value = (this.value && this.value.variations) || null;
      }

      // initialize list of variations we will delete
      this.valueVariationsToDelete = Object.keys(value);

      // delete original file, this triggers lambdas that will remove all variations and their fragments
      // The "if" confirms that the value is set - it's possible we have a corrupt parent record with no
      // index.json fragment (which would be loaded in mounted). By skipping deleteObjectFromWorkspace,
      // we can get the record back to a stable state.
      // The filepath to the original file is only available in the fragment json from the _default file
      // which was loaded in mounted()
      if (this.variationFragments._default && this.variationFragments._default.path) {
        await this.$store.state.sdk.deleteObjectFromWorkspace(this.variationFragments._default.path);
      }

      // initialize polling of remaining fragment files, wait 0.5s before we start...
      // this might still leave orphan files if the value has lost a relation to a file
      Object.keys(value).map((variationName) => {
        setTimeout(this.confirmFragmentDeleted, 500, variationName, value[variationName]);
      });
    },
    async unsetValue() {
      this.url = null;
      this.localPreview = false;
      this.value = null;
      this.filename = null;
      this.loading = false;
      this.detachFileDialog = false;
      this.deletedVariationFragments = [];
      this.valueVariationsToDelete = [];
    },
    async fetchDefaultVariationFragment() {
      if (!this.value) {
        return;
      }
      this.variationFragmentFetchAttempts++;
      this.loading = true;
      let pathSegments;
      // Video/audio
      if (this.value.variations && this.value.variations._default) {
        try {
          const fragment = await this.$store.state.sdk.getDocument(this.value.variations._default);
          this.variationFragments._default = fragment;
          this.url = await this.$store.state.sdk.getSignedUrl(this.variationFragments._default.path);
          pathSegments = this.variationFragments._default.path.split('/');
          this.filename = pathSegments.pop();
          this.dummyFile = new File(['dummyFile'], this.filename, { type: 'text/plain' });
        } catch (e) {
          console.error('Unable to load original file fragment.', e);
        }
        // Images
      } else if (this.value._default) {
        // Attempt to load thumbnail fragment
        if (this.value._thumbnail) {
          try {
            const fragment = await this.$store.state.sdk.getDocument(this.value._thumbnail);
            this.variationFragments._thumbnail = fragment;
            this.url = await this.$store.state.sdk.getSignedUrl(this.variationFragments._thumbnail.path);
            pathSegments = this.variationFragments._thumbnail.path.split('/');
            this.filename = pathSegments.pop();
            this.dummyFile = new File(['dummyFile'], this.filename, { type: 'text/plain' });
          } catch (e) {
            // ignore this
          }
        }

        // Always load default fragment (required when detaching, for example)
        try {
          const fragment = await this.$store.state.sdk.getDocument(this.value._default);
          this.variationFragments._default = fragment;
          // when no thumbnail exists, fallback to this file
          if (!this.url) {
            this.url = await this.$store.state.sdk.getSignedUrl(this.variationFragments._default.path);
            pathSegments = this.variationFragments._default.path.split('/');
            this.filename = pathSegments.pop();
            this.dummyFile = new File(['dummyFile'], this.filename, { type: 'text/plain' });
          }
        } catch (e) {
          console.error('Unable to load original file fragment.', e);
        }

        // Unknown???
      } else if (typeof this.value === 'string') {
        try {
          const fragment = await this.$store.state.sdk.getDocument(this.value);
          this.variationFragments._default = fragment;
          this.url = await this.$store.state.sdk.getSignedUrl(this.variationFragments._default.path);
          pathSegments = this.variationFragments._default.path.split('/');
          this.filename = pathSegments.pop();
          this.dummyFile = new File(['dummyFile'], this.filename, { type: 'text/plain' });
        } catch (e) {
          console.error('Unable to load original file fragment.', e);
        }
      }

      // try again!
      if (!this.url && this.variationFragmentFetchAttempts < 5) {
        setTimeout(async () => {
          await this.fetchDefaultVariationFragment();
        }, 1000 * this.variationFragmentFetchAttempts);
      } else if (this.url) {
        this.loading = false;
      }
    }
  },
  async mounted() {
    this.enhancedRules = [
      ...this.validationRules, 
      (value) =>{
        this.validFilename = true;
        if (new RegExp(/^[a-zA-Z-_0-9]+\.[^A-Z]+$/).test((value?.name??'')) || !value) return true;
        this.value = null;
        this.validFilename = false;
        return this.$t('validation.mustMatchFilename')
      }
    ];
    // this.loading = true;
    await this.fetchDefaultVariationFragment();
  }
};
